<template>
  <div>
    <div v-if="loadingCoupon">
      <ws-cary-spinner height="20px" />
      <span class="coupon-auto-insert__loading-text">
        {{ t("general.coupon_auto_insert") }}
      </span>
    </div>
    <ws-state-banner v-else-if="autoInsertError" type="error" class="q-mb-md">
      {{ t("validation.coupon_not_applicable") }}
    </ws-state-banner>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { applyCoupon } from '@/services/cart/cart-api.service.ts';
import { logError } from '@/services/logger.service.ts';
import { WsCarySpinner, WsStateBanner } from '@odin/components-vue2';
import { useI18n } from '@odin/services';

export default defineComponent({
  components: {
    WsCarySpinner,
    WsStateBanner,
  },
  setup() {
    const router = useRouter();
    const { t } = useI18n();

    const loadingCoupon = ref(false);
    const autoInsertError = ref(false);

    const checkForCoupon = async () => {
      autoInsertError.value = false;
      const coupon = router.currentRoute.query.coupon;
      if (!coupon) {
        return;
      }
      await addCoupon(coupon.toString());
    };

    const addCoupon = async (coupon: string) => {
      loadingCoupon.value = true;
      autoInsertError.value = false;
      try {
        await applyCoupon(coupon);
      } catch (e) {
        logError('Error while auto-insert coupon', e);
        autoInsertError.value = true;
      } finally {
        loadingCoupon.value = false;
      }
    };

    onMounted(async () => {
      await checkForCoupon();
    });

    return { t, loadingCoupon, autoInsertError };
  },
});
</script>

<style scoped lang="scss">
.coupon-auto-insert {
  &__loading-text {
    color: $ws-dark-gray;
  }
}
</style>
